const NotFound = () => {
  return (
    <div className="w-full flex justify-center items-center text-gray-400 text-5xl">
      Akun Belum Diverivikasi Admin
    </div>
  );
};

export default NotFound;
